module.exports = __webpack_public_path__ + "img/p7.e246955c.png";